import { accountActions } from '@store/actions';
import { createFailureActionType, createReducer } from '@store/utils';

const {
    logout,
    getProfileSuccess,
    getProfile,
} = accountActions;

const initialState = {
    profile: null,
};

const accountReducer = createReducer(
    {
        reducerName: 'account',
        initialState,
        // storage: true,
        storage: false,
    },
    {
        [getProfileSuccess.type]: (state, { payload }) => {
            state.profile = payload?.data || null;
        },
        [createFailureActionType(getProfile.type)]: (state, { payload }) => {

        },
        [logout.type]: (state) => {
            state.profile = null;
        },
    },
);

export default accountReducer;
